// extracted by mini-css-extract-plugin
export var boldText = "_72-4";
export var checkboxContainer = "_72-6";
export var closeIcon = "_72-i";
export var container = "_72-0";
export var drawer = "_72-8";
export var drawerContent = "_72-9";
export var extraSmallText = "_72-5";
export var fulfillmentGroupTable = "_72-e";
export var largeText = "_72-3";
export var loadingSpinnerContainer = "_72-j";
export var mediumText = "_72-2";
export var narrow = "_72-f";
export var notificationLink = "_72-l";
export var packageCheckIconContainer = "_72-7";
export var slideoutHeaderActions = "_72-g";
export var slideoutHeaderActionsShifted = "_72-h";
export var slideoutHeaderContainer = "_72-a";
export var slideoutModal = "_72-c";
export var stickyHeaderWrapper = "_72-b";
export var table = "_72-k";
export var tableContainer = "_72-d";
export var tertiaryText = "_72-1";